import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';
import { persistState } from '@ngneat/elf-persist-state';
import { createRequestDataSource, createRequestsStatusOperator, initializeAsPending, withRequestsCache, withRequestsStatus } from '@ngneat/elf-requests';
import { FaqCategory } from '@timechef/core/api';
import { capacitorStorageStrategy, includeKeys } from '@timechef/core/utils/elf-utils';

interface FaqProps {
  categories: FaqCategory[];
}

export enum FaqStatusKey {
  Faq = 'faq',
}

export interface Lieu {
  id: number;
  libelle: string;
}

@Injectable({ providedIn: 'root' })
export class FaqRepository {
  private store = createStore(
    { name: 'faq' },
    withProps<FaqProps>({
      categories: [],
    }),
    withRequestsStatus(initializeAsPending(FaqStatusKey.Faq)),
    withRequestsCache<FaqStatusKey.Faq>(),
  );

  instance = persistState(this.store, {
    key: 'faq',
    storage: capacitorStorageStrategy,
    source: () => this.store.pipe(includeKeys(['requestsCache'])),
  });

  faqAuthenticationDS = createRequestDataSource({
    store: this.store,
    data$: () => this.store.pipe(select((s) => s.categories)),
    dataKey: 'data',
    requestKey: FaqStatusKey.Faq,
  });

  updateFaqQuestions(result: FaqCategory[]) {
    this.store.update(this.faqAuthenticationDS.setSuccess(), (s) => ({ ...s, categories: result }));
  }

  public trackRequestStatus = createRequestsStatusOperator(this.store);
}
